// extracted by mini-css-extract-plugin
export default {"content":"ContactPage_content__zgO6w"};